module.exports = __webpack_public_path__ + "static/gatsby-6134ffb082469deaa95c57359849b290.svg";